export function createEndpoints<T extends Record<string, any>>(
  version: 'v1' | 'v2',
  endpoints: T,
): any {
  const result: any = {};

  for (const key in endpoints) {
    const value = endpoints[key];

    if (typeof value === 'function') {
      result[key] = (...args: any[]) => ({
        path: value(...args),
        version,
      });
    } else {
      result[key] = {
        path: value,
        version,
      };
    }
  }

  return result;
}
